var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnoti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1168"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 17.5,
    cy: 17.5,
    r: 17.25,
    fill: "#959595",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 23.77V22.77H12.615V14.845C12.615 13.5383 13.0283 12.3893 13.855 11.398C14.683 10.4073 15.7313 9.79 17 9.546V8H19V9.546C20.2693 9.79 21.3173 10.4077 22.144 11.399C22.9707 12.391 23.384 13.54 23.384 14.846V22.769H25V23.769H11V23.77ZM17.997 26.385C17.5517 26.385 17.1717 26.2267 16.857 25.91C16.5423 25.594 16.385 25.214 16.385 24.77H19.615C19.615 25.2167 19.4567 25.5977 19.14 25.913C18.8227 26.2277 18.4417 26.385 17.997 26.385Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnoti);
export default __webpack_public_path__ + "static/media/bnoti.66b34490be1a7c8abff7d57d5a936261.svg";
export { ForwardRef as ReactComponent };